<div style="width: 100%">
    <mat-form-field [ngClass]="noPaddingNoMargin ? 'no-padding-margin-mat-form-field' : ''" style="width: 100%">
        <mat-label>{{ placeholder }}</mat-label>
        <input
            #inputAutocomplete="matInput"
            matInput
            #trigger="matAutocompleteTrigger"
            [matAutocomplete]="auto"
            [formControl]="formControl"
            [required]="required"
            (blur)="onBlur()"
            [placeholder]="placeholder"
            [attr.data-cy]="'ckaka_input_1'"
        />

        <button
            *ngIf="showClear"
            [disabled]="disabled"
            matSuffix
            mat-icon-button
            type="button"
            color="accent"
            (click)="clear()"
            [attr.data-cy]="'ckaka_button_1'"
        >
            <mat-icon [attr.data-cy]="'ckaka_icon_clear'">cancel</mat-icon>
        </button>

        <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="mapper.bind(this)"
            (optionSelected)="emitSelectedElement($event)"
            (optionActivated)="setActivatedObject($event)"
            [attr.data-cy]="'ckaka_autocomplete_1'"
        >
            <ng-container *ngIf="createNewEvent">
                <mat-option
                    *kienePermission="createNewEvent?.permission"
                    (click)="emitCreateNewEvent()"
                    style="position: sticky; bottom: 0; background-color: #efefef; border-top: 1px solid #ccc"
                    [attr.data-cy]="'ckaka_option_create'"
                >
                    <mat-icon [attr.data-cy]="'ckaka_icon_create'">add</mat-icon>
                    <span>{{ createNewEvent?.buttonText }}</span>
                </mat-option>
            </ng-container>

            <mat-option *ngIf="resetValue" [attr.data-cy]="'ckaka_option_reset'">
                {{ resetValue }}
            </mat-option>

            <mat-option
                *ngFor="let o of options | async; let i = index"
                [value]="o"
                [attr.data-cy]="'ckaka_option_' + i"
            >
                <div class="one-row">
                    {{ getValue(o) }}
                    <span class="spacer"></span>
                    <div *ngIf="showDeleteButton">
                        <button
                            mat-icon-button
                            (click)="deleteElement($event, o)"
                            [attr.data-cy]="'ckaka_delete_button_' + i"
                        >
                            <mat-icon [attr.data-cy]="'ckaka_delete_icon_' + i">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</div>
